import { Laya } from "../../../../Laya";
import { LayaGL } from "../../../layagl/LayaGL";
import { RenderState } from "../Design/RenderState";
import { WebDefineDatas } from "./WebDefineDatas";
import { WebShaderPass } from "./WebShaderPass";
import { WebSubShader } from "./WebSubShader";
export class WebUnitRenderModuleDataFactory {
    createSubShader() {
        return new WebSubShader();
    }
    createShaderPass(pass) {
        return new WebShaderPass(pass);
    }
    createRenderState() {
        return new RenderState();
    }
    createDefineDatas() {
        return new WebDefineDatas();
    }
}
Laya.addBeforeInitCallback(() => {
    if (!LayaGL.unitRenderModuleDataFactory)
        LayaGL.unitRenderModuleDataFactory = new WebUnitRenderModuleDataFactory();
});
